import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {Material} from '../types'

export const MaterialsSnapshotQueryKey = 'materialsSnapshot'

type Params<TReturn = Material[]> = {
  plantCode: string
  snapshotDateTime: string
  options?: Omit<UseQueryOptions<Material[], AxiosError, TReturn>, 'queryKey' | 'queryFn'>
}

export const useMaterialsSnapshot = <TReturn = Material[]>({
  plantCode,
  snapshotDateTime,
  options
}: Params<TReturn>) =>
  useQuery<Material[], AxiosError, TReturn>({
    queryKey: [MaterialsSnapshotQueryKey, snapshotDateTime, plantCode] as const,
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<Material[]>(
        `/plants/${plantCode}/materials/history/${snapshotDateTime}`,
        {signal}
      )
      return response.data || []
    },
    ...options
  })
